const BaseURL = "https://mmh-backend.vercel.app"


export default BaseURL